import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.shared-accounts.request-center.requests', {
        url: '/access-requests',
        views: {
            '@user.shared-accounts.request-center': 'accessRequests',
        },
        resolve: {requests},
    })
}

/** @ngInject */
function requests(RequestCenterService) {
    return RequestCenterService.getRequests();
}



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/requests/access-requests.state.js